import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "cookbook"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "title"
};
import { ref, watch } from 'vue';
import CardHeader from './CardHeader.vue';
export default {
  __name: 'MonthHotCookbook',
  props: {
    cookbookList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(__props) {
    let props = __props;
    let dataList = ref();
    watch(() => props.cookbookList, newValue => {
      dataList.value = newValue || [];
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CardHeader, {
        title: "当月热门菜谱"
      }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id
        }, [_createVNode(_component_el_image, {
          class: "image",
          fit: "cover",
          src: item.url
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1)]);
      }), 128))])]);
    };
  }
};